import script from "./LoginNext.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginNext.vue?vue&type=script&setup=true&lang=js"

import "./LoginNext.vue?vue&type=style&index=0&id=2e20521d&lang=css"
import "./LoginNext.vue?vue&type=style&index=1&id=2e20521d&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\CSD.SPA\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e20521d"]])

export default __exports__